var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { Redirect, withRouter } from 'react-router';
import Loading from 'components/shared/Loading';
import Error from 'components/shared/Error';
import PostWriter from './PostWriter';
var GET_POST = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query ReadPostWithoutCounting($boardId: String!, $numberInBoard: Int!) {\n    readPostWithoutCounting(boardId: $boardId, numberInBoard: $numberInBoard) {\n      id\n      title\n      author {\n        id\n      }\n      category\n      content\n      numberInBoard\n      count\n      filesUrl\n      thumbnailUrl\n    }\n    currentUser {\n      id\n    }\n  }\n"], ["\n  query ReadPostWithoutCounting($boardId: String!, $numberInBoard: Int!) {\n    readPostWithoutCounting(boardId: $boardId, numberInBoard: $numberInBoard) {\n      id\n      title\n      author {\n        id\n      }\n      category\n      content\n      numberInBoard\n      count\n      filesUrl\n      thumbnailUrl\n    }\n    currentUser {\n      id\n    }\n  }\n"])));
var MODIFY_POST = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  mutation ModifyPost($post: ModifyingPostPayload!) {\n    modifyPost(post: $post) {\n      numberInBoard\n    }\n  }\n"], ["\n  mutation ModifyPost($post: ModifyingPostPayload!) {\n    modifyPost(post: $post) {\n      numberInBoard\n    }\n  }\n"])));
var PostModifier = /** @class */ (function (_super) {
    __extends(PostModifier, _super);
    function PostModifier() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modify = function (values, client) { return __awaiter(_this, void 0, void 0, function () {
            var _a, boardId, match, history, post, urls;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, boardId = _a.boardId, match = _a.match, history = _a.history;
                        post = {
                            parent: boardId,
                            title: values.title,
                            content: values.content,
                            category: values.category,
                            secretPostIs: values.secretPostIs,
                            numberInBoard: this.getNIBfromURL(),
                        };
                        return [4 /*yield*/, client.mutate({
                                mutation: MODIFY_POST,
                                variables: {
                                    post: post,
                                },
                            })];
                    case 1:
                        _b.sent();
                        urls = match.url.split('/');
                        urls.pop();
                        history.push(urls.join('/'));
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    PostModifier.prototype.getNIBfromURL = function () {
        var urls = this.props.match.url.split('/');
        return Number(urls[urls.length - 2]);
    };
    PostModifier.prototype.render = function () {
        var _this = this;
        var boardId = this.props.boardId;
        var numberInBoard = this.getNIBfromURL();
        return (React.createElement(Query, { query: GET_POST, variables: {
                boardId: boardId,
                numberInBoard: numberInBoard,
            }, fetchPolicy: "network-only" }, function (_a) {
            var loading = _a.loading, error = _a.error, data = _a.data;
            if (loading)
                return React.createElement(Loading, null);
            if (error || !data.readPostWithoutCounting)
                return React.createElement(Error, { error: error });
            if (!data.currentUser ||
                (data.currentUser &&
                    data.currentUser.id !== data.readPostWithoutCounting.author.id)) {
                return React.createElement(Redirect, { to: "/" });
            }
            return (React.createElement(PostWriter, __assign({}, _this.props, data.readPostWithoutCounting, { submitButtonText: "\uC218\uC815", onSubmit: _this.modify })));
        }));
    };
    PostModifier = __decorate([
        withRouter
    ], PostModifier);
    return PostModifier;
}(React.Component));
export default PostModifier;
var templateObject_1, templateObject_2;
